import { UseMutationResult } from "@tanstack/react-query";
import { ErrorData } from "../config/interfaces";

interface IinputValidate {
  type: string;
  setState: React.Dispatch<React.SetStateAction<ErrorData>>;
  mutation?: UseMutationResult;
  props?: {
    dialCode: string;
    method?: string;
  };
}

export const inputValidate = ({
  type,
  setState,
  mutation,
  props,
}: IinputValidate) => {
  const element = document.getElementById(type) as HTMLInputElement;
  let isValid = true;

  if (type === "name") {
    if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "이름을 입력해주세요."
            : "Please provide your name.",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });
    }
  } else if (type === "birth") {
    if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "생년월일을 입력해주세요."
            : "Please provide your birth.",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });
    }
  } else if (type === "username") {
    if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "이메일을 입력해주세요."
            : "Please provide your email.",
      });

      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(element.value)
    ) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "이메일을 정확히 입력해주세요."
            : "Please check your email.",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });
    }

    // else {
    //   if (!/\S+@\S+\.\S+/.test(element.value)) {
    //     setState({
    //       error: true,
    //       message: "Please check your email or phone number.",
    //     });

    //     isValid = false;
    //   } else {
    //     setState({
    //       error: false,
    //       message: "",
    //     });
    //   }

    //   if (!isValid && !/^\d{10,11}$/.test(element.value)) {
    //     setState({
    //       error: true,
    //       message: "Please check your email or phone number.",
    //     });

    //     isValid = false;
    //   } else {
    //     setState({
    //       error: false,
    //       message: "",
    //     });
    //   }
    // }
  } else if (type === "password") {
    if (
      !/^(?=.*[a-zA-Z])(?=.*[#?!@$%^&*-])(?=.*[0-9]).{8,15}$/.test(
        element.value
      )
    ) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "비밀번호를 정확히 입력해주세요. (특수문자, 대문자, 소문자, 숫자 포함 8-15자리)"
            : "Use 8-15 characters with a mix of uppercase & lowercase, numbers & symbols",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });
    }

    return isValid;
  } else if (type === "password-confirm") {
    const password = document.getElementById("password") as HTMLInputElement;

    if (element.value !== password.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "비밀번호를 확인해주세요."
            : "Please check your password.",
      });

      isValid = false;
    } else if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "비밀번호를 입력해주세요."
            : "Please provide your password.",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });
    }

    return isValid;
  } else if (type === "phone") {
    if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "전화번호를 입력해주세요."
            : "Please provide your phone number.",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });

      let phoneData;
      const regex = /[^0-9]/g;

      const originalNumber = element.value;
      if (originalNumber.charAt(0) === "0") {
        phoneData = `+${props?.dialCode}${originalNumber
          .substring(1)
          .replace(regex, "")}`;
      } else {
        phoneData = `+${props?.dialCode}${originalNumber.replace(regex, "")}`;
      }

      mutation?.mutate({
        target: phoneData,
      });
    }

    return isValid;
  } else if (type === "email") {
    if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "이메일을 입력해주세요."
            : "Please provide your email.",
      });

      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(element.value)
    ) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "이메일을 정확히 입력해주세요."
            : "Please check your email.",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });

      mutation?.mutate({
        target: element.value,
      });
    }

    return isValid;
  } else if (type === "code") {
    if (props?.method === "email") {
      const email = document.getElementById("email") as HTMLInputElement;

      if (!element.value || !/^[0-9]{6}$/.test(element.value)) {
        setState({
          error: true,
          message:
            props?.dialCode === "82"
              ? "인증코드를 정확히 확인해주세요."
              : "Please check your verification code.",
        });

        isValid = false;
      } else {
        mutation?.mutate({
          target: email.value,
          code: element.value,
        });
      }
    } else if (props?.method === "phone") {
      const phone = document.getElementById("phone") as HTMLInputElement;

      if (!element.value || !/^[0-9]{6}$/.test(element.value)) {
        setState({
          error: true,
          message:
            props?.dialCode === "82"
              ? "인증코드를 정확히 확인해주세요."
              : "Please check your verification code.",
        });

        isValid = false;
      } else {
        let phoneData;
        const regex = /[^0-9]/g;

        const originalNumber = phone.value;
        if (originalNumber.charAt(0) === "0") {
          phoneData = `+${props?.dialCode}${originalNumber
            .substring(1)
            .replace(regex, "")}`;
        } else {
          phoneData = `+${props?.dialCode}${originalNumber.replace(regex, "")}`;
        }

        mutation?.mutate({
          target: phoneData,
          code: element.value,
        });
      }
    }
  } else if (type === "change-password") {
    if (
      !/^(?=.*[a-zA-Z])(?=.*[#?!@$%^&*-])(?=.*[0-9]).{8,15}$/.test(
        element.value
      )
    ) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "비밀번호를 정확히 입력해주세요. (특수문자, 대문자, 소문자, 숫자 포함 8-15자리)"
            : "Use 8-15 characters with a mix of uppercase & lowercase, numbers & symbols",
      });

      isValid = false;
    } else if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "비밀번호를 입력해주세요."
            : "Please provide your password.",
      });

      isValid = false;
    } else {
      setState({
        error: false,
        message: "",
      });
    }

    return isValid;
  } else if (type === "change-password-confirm") {
    const password = document.getElementById(
      "change-password"
    ) as HTMLInputElement;
    const phone = document.getElementById("phone") as HTMLInputElement;

    if (element.value !== password.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "비밀번호를 확인해주세요."
            : "Please check your password.",
      });

      isValid = false;
    } else if (!element.value) {
      setState({
        error: true,
        message:
          props?.dialCode === "82"
            ? "비밀번호를 확인해주세요."
            : "Please check your password.",
      });

      isValid = false;
    } else {
      // mutation?.mutate({
      //   password1: password.value,
      //   password2: element.value,
      // });
      let phoneData;
      const regex = /[^0-9]/g;

      const originalNumber = phone.value;
      if (originalNumber.charAt(0) === "0") {
        phoneData = `+${props?.dialCode}${originalNumber
          .substring(1)
          .replace(regex, "")}`;
      } else {
        phoneData = `+${props?.dialCode}${originalNumber.replace(regex, "")}`;
      }

      mutation?.mutate({
        target: phoneData,
      });
    }

    return isValid;
  }

  return isValid;
};
